import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25cb9cd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10 mt-10" }
const _hoisted_3 = { class: "d-flex justify-content-center fs-1 fw-bolder mb-10" }
const _hoisted_4 = {
  ref: "BorangPerkhidmatan",
  class: "card p-5 stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_5 = { class: "stepper-nav py-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stepper-item current",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "stepper-title" }, "Butir-Butir Diri")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "stepper-title" }, "Butir-Butir Perkhidmatan")
], -1))
const _hoisted_8 = {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "stepper-title" }, "Butir-Butir Badan Ikhtisas", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stepper-item",
  "data-kt-stepper-element": "nav"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "stepper-title" }, "Pengesahan")
], -1))
const _hoisted_12 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "row gx-10 mb-5" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Butir-Butir Diri")
], -1))
const _hoisted_17 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_18 = { class: "mb-5 col-lg-6 pe-2" }
const _hoisted_19 = { class: "mb-2 fv-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "No. Kad Pengenalan Baharu", -1))
const _hoisted_21 = { class: "mb-5 col-lg-6 ps-2" }
const _hoisted_22 = { class: "mb-2 fv-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Jantina", -1))
const _hoisted_24 = { class: "d-flex justify-content-left mb-2" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-5" }, " LELAKI ", -1))
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-5" }, " PEREMPUAN ", -1))
const _hoisted_29 = { class: "mb-5" }
const _hoisted_30 = { class: "mb-2 fv-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Nama Penuh", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_33 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_34 = { class: "mb-5 col-lg-6 pe-2" }
const _hoisted_35 = { class: "mb-2 fv-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-2" }, "Tarikh Lahir", -1))
const _hoisted_37 = { class: "mb-5 col-lg-6 ps-2" }
const _hoisted_38 = { class: "mb-2 fv-row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Umur", -1))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_42 = { class: "col-lg-6 pe-2" }
const _hoisted_43 = { class: "fv-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "No. Telefon Bimbit", -1))
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "col-lg-6 ps-2" }
const _hoisted_47 = { class: "fv-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "E-mel", -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_51 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_52 = { class: "mb-5 col-lg-6 pe-2" }
const _hoisted_53 = { class: "mb-2 fv-row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Bangsa", -1))
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["value"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "mb-5 col-lg-6 ps-2" }
const _hoisted_59 = { class: "mb-2 fv-row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Agama", -1))
const _hoisted_61 = { key: 0 }
const _hoisted_62 = ["value"]
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "mb-5" }
const _hoisted_65 = { class: "mb-2 fv-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Alamat Surat Menyurat", -1))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_69 = { class: "mb-5 d-flex justify-content-center" }
const _hoisted_70 = { class: "col-lg-6 pe-2" }
const _hoisted_71 = { class: "fv-row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Negeri", -1))
const _hoisted_73 = { key: 0 }
const _hoisted_74 = ["value"]
const _hoisted_75 = { key: 1 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_77 = { class: "col-lg-6 ps-2" }
const _hoisted_78 = { class: "fv-row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Poskod", -1))
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_83 = { class: "mb-5" }
const _hoisted_84 = { class: "d-flex" }
const _hoisted_85 = { class: "col-lg-6 pe-2" }
const _hoisted_86 = { class: "fv-row" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status Perkahwinan", -1))
const _hoisted_88 = { key: 0 }
const _hoisted_89 = ["value"]
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "row gx-10 mb-2" }
const _hoisted_92 = {
  key: 0,
  class: "col-lg-6",
  style: {"padding-right":"0.25rem"}
}
const _hoisted_93 = { "data-kt-stepper-element": "content" }
const _hoisted_94 = { class: "w-100" }
const _hoisted_95 = { class: "row gx-10 mb-2" }
const _hoisted_96 = { class: "col-lg-12" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Butir-Butir Perkhidmatan")
], -1))
const _hoisted_98 = { class: "mb-2" }
const _hoisted_99 = { class: "mb-2 fv-row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Jawatan Hakiki", -1))
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { class: "mb-2" }
const _hoisted_104 = { class: "mb-2 fv-row" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Gred Jawatan Semasa", -1))
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_109 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_110 = { class: "col-lg-6 pe-2" }
const _hoisted_111 = { class: "mb-2 fv-row" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Lantikan Ke Perkhidmatan Sekarang", -1))
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { class: "col-lg-6 ps-2" }
const _hoisted_116 = { class: "mb-2 fv-row" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Sah ke Perkhidmatan", -1))
const _hoisted_118 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_119 = { class: "col-lg-6 ps-2" }
const _hoisted_120 = { class: "mb-2 fv-row" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tarikh Memangku", -1))
const _hoisted_122 = { class: "col-lg-6 pe-2" }
const _hoisted_123 = {
  key: 0,
  class: "mb-2 fv-row"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh Kenaikan Pangkat Terakhir", -1))
const _hoisted_125 = { class: "mb-5" }
const _hoisted_126 = { class: "d-flex justify-content-between" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Jenis Persaraan", -1))
const _hoisted_128 = { class: "form-check form-switch form-switch-lg form-check-custom form-check-solid" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mx-2" }, "Wajib", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Pilihan", -1))
const _hoisted_131 = {
  key: 0,
  style: {"width":"50%"},
  class: "form-select",
  name: "WajibPersaraan"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "PILIH", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "55" }, "55 Tahun", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "56" }, "56 Tahun", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "58" }, "58 Tahun", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "60" }, "60 Tahun", -1))
const _hoisted_137 = [
  _hoisted_132,
  _hoisted_133,
  _hoisted_134,
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = { class: "mb-2" }
const _hoisted_139 = { class: "mb-2 fv-row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Kementerian", -1))
const _hoisted_141 = { key: 0 }
const _hoisted_142 = ["value"]
const _hoisted_143 = { key: 1 }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_145 = { class: "mb-2" }
const _hoisted_146 = { class: "mb-2 fv-row" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Alamat Tempat Kerja", -1))
const _hoisted_148 = ["disabled"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_150 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_151 = { class: "col-lg-6 pe-2" }
const _hoisted_152 = { class: "fv-row" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Negeri Pejabat", -1))
const _hoisted_154 = { key: 0 }
const _hoisted_155 = ["value"]
const _hoisted_156 = { key: 1 }
const _hoisted_157 = ["value"]
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_159 = { class: "col-lg-6 ps-2" }
const _hoisted_160 = { class: "fv-row" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Poskod", -1))
const _hoisted_162 = { key: 0 }
const _hoisted_163 = { key: 1 }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_165 = { class: "mb-2 d-flex justify-content-center" }
const _hoisted_166 = { class: "mb-2 col-lg-6 pe-2" }
const _hoisted_167 = { class: "mb-2 fv-row" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Telefon Pejabat", -1))
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "mb-2 col-lg-6 ps-2" }
const _hoisted_171 = { class: "mb-2 fv-row" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Faks", -1))
const _hoisted_173 = ["disabled"]
const _hoisted_174 = {
  key: 0,
  class: "text-muted text-end fst-italic"
}
const _hoisted_175 = { class: "mb-2" }
const _hoisted_176 = { class: "mb-2 fv-row" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Jabatan Bertugas Semasa", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_179 = { class: "mb-2" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Negeri", -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "",
  selected: ""
}, /*#__PURE__*/_toDisplayString("Sila Pilih Negeri"), -1))
const _hoisted_182 = ["value"]
const _hoisted_183 = { class: "mb-2" }
const _hoisted_184 = { class: "mb-2 fv-row" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Daerah", -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_187 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_188 = { class: "col-lg-6 pe-2" }
const _hoisted_189 = { class: "mb-2 fv-row" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "E-mel Ketua Jabatan", -1))
const _hoisted_191 = { class: "col-lg-6 ps-2" }
const _hoisted_192 = { class: "mb-2 fv-row d-none" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "E-mel PSM", -1))
const _hoisted_194 = { key: 1 }
const _hoisted_195 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_196 = { class: "col-lg-12 pe-2" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-800 text-hover-primary mt-7" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Sijil Badan Ikhtisas")
], -1))
const _hoisted_198 = { class: "mb-2" }
const _hoisted_199 = { class: "mb-2 fv-row" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Nama Sijil Badan Ikhtisas", -1))
const _hoisted_201 = { class: "mb-2" }
const _hoisted_202 = { class: "mb-2 fv-row" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Sijil Badan Ikhtisas", -1))
const _hoisted_204 = ["href"]
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-danger text-end fs-7 fst-italic" }, "Sila muatnaik Sijil Badan Ikhtisas (format PDF, minimum 5mb)", -1))
const _hoisted_206 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_207 = { class: "col-lg-12 pe-2" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-gray-800 text-hover-primary mt-7" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Pinjaman Pendidikan")
], -1))
const _hoisted_209 = { class: "mb-2 fv-row" }
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Kenyataan", -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1))
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Tiada" }, " Tidak Mengambil Pinjaman Pendidikan ", -1))
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Dalam_Proses" }, " Masih Dalam Proses Pembayaran (Penyata Pembayaran Dikepilkan Bersama) ", -1))
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Selesai" }, " Telah Selesai Bayaran Pinjaman Pendidikan (Surat Akaun Pembayaran Penuh Pinjaman Dikepilkan Bersama) ", -1))
const _hoisted_215 = [
  _hoisted_211,
  _hoisted_212,
  _hoisted_213,
  _hoisted_214
]
const _hoisted_216 = { class: "mb-1 d-flex justify-content-center" }
const _hoisted_217 = { class: "col-lg-6 pe-2" }
const _hoisted_218 = { class: "mb-2 fv-row" }
const _hoisted_219 = {
  key: 0,
  class: "required form-label"
}
const _hoisted_220 = {
  key: 1,
  class: "form-label"
}
const _hoisted_221 = ["disabled"]
const _hoisted_222 = { class: "col-lg-6 ps-2" }
const _hoisted_223 = { class: "mb-2 fv-row" }
const _hoisted_224 = {
  key: 0,
  class: "required form-label"
}
const _hoisted_225 = {
  key: 1,
  class: "form-label"
}
const _hoisted_226 = { key: 2 }
const _hoisted_227 = ["href"]
const _hoisted_228 = { "data-kt-stepper-element": "content" }
const _hoisted_229 = { class: "w-100" }
const _hoisted_230 = { class: "row gx-10 mb-5" }
const _hoisted_231 = { class: "col-lg-12" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 d-flex mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fw-bolder fs-2 d-flex align-items-end",
    style: {"line-height":"0.65"}
  }, "1. Maklumat Keahlian MIA "),
  /*#__PURE__*/_createElementVNode("i", { class: "text-gray-700 fs-7 d-flex align-items-end" }, "(Syarat Wajib)")
], -1))
const _hoisted_233 = { class: "mb-10 d-flex flex-wrap justify-content-start" }
const _hoisted_234 = { class: "col-lg-4" }
const _hoisted_235 = { class: "mb-2 fv-row" }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "a) Keahlian MIA", -1))
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Pilihan Keahlian ", -1))
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Ya" }, "Ya", -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Tidak" }, "Tidak", -1))
const _hoisted_240 = [
  _hoisted_237,
  _hoisted_238,
  _hoisted_239
]
const _hoisted_241 = { class: "col-lg-4 px-3" }
const _hoisted_242 = { class: "mb-2 fv-row" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "b) No. Keahlian MIA", -1))
const _hoisted_244 = { class: "col-lg-4" }
const _hoisted_245 = { class: "mb-2 fv-row" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "c) Tarikh Keahlian MIA", -1))
const _hoisted_247 = { class: "col-lg-4 me-auto" }
const _hoisted_248 = { class: "mb-2 fv-row" }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Muat Naik Sijil MIA", -1))
const _hoisted_250 = ["href"]
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 d-flex mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fw-bolder fs-2 d-flex align-items-end",
    style: {"line-height":"0.65"}
  }, "2. Senarai Badan Ikhtisas")
], -1))
const _hoisted_252 = { class: "mb-5 d-flex flex-wrap justify-content-start" }
const _hoisted_253 = { class: "col-lg-4" }
const _hoisted_254 = { class: "mb-2 fv-row" }
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label h-100" }, "Badan Ikhtisas", -1))
const _hoisted_256 = { class: "mb-2 d-flex text-bottom" }
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-5 px-2" }, " a. ", -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Pilihan Badan Ikhtisas", -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "MACPA" }, " Malaysian Association of Certified Public Accountants (MACPA) ", -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ICAS" }, " Institute of Chartered Accountants of Scotland (ICAS) ", -1))
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ICAEW" }, " Institute of Chartered Accountants in England and Wales (ICAEW) ", -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ICAI" }, " Institute of Chartered Accountants in Ireland (ICAI) ", -1))
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ACCA" }, " Association of Chartered Certified Accountants (ACCA) ", -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ICAA" }, " Institute of Chartered Accountants in Australia (ICAA) ", -1))
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "CPA Australia" }, " Australian Society of Certified Practising Accountants (CPA Australia) ", -1))
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "NZICA" }, " New Zealand Chartered Accountants (NZICA) ", -1))
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "CICA" }, " Canadian Institute of Chartered Accountants (CICA) ", -1))
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ICAI" }, " Institute of Chartered Accountants of India (ICAI) ", -1))
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "CIMA" }, " Chartered Institute of Management Accountants (CIMA) ", -1))
const _hoisted_270 = [
  _hoisted_258,
  _hoisted_259,
  _hoisted_260,
  _hoisted_261,
  _hoisted_262,
  _hoisted_263,
  _hoisted_264,
  _hoisted_265,
  _hoisted_266,
  _hoisted_267,
  _hoisted_268,
  _hoisted_269
]
const _hoisted_271 = {
  class: "col-lg-4 px-3",
  style: {"padding-right":"0.375rem !important"}
}
const _hoisted_272 = { class: "mb-2 fv-row" }
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Tarikh LULUS Peperiksaan", -1))
const _hoisted_274 = {
  class: "col-lg-4 px-3",
  style: {"padding-left":"0.375rem !important"}
}
const _hoisted_275 = { class: "mb-2 fv-row" }
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "required form-label",
  style: {"max-width":"220px","max-height":"21px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}, " Tarikh Keahlian Penuh Diluluskan ", -1))
const _hoisted_277 = {
  class: "col-lg-4 px-3",
  style: {"padding-left":"0.375rem !important"}
}
const _hoisted_278 = { class: "mb-2 fv-row" }
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  style: {"max-width":"200px","max-height":"21px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}, "No. Keahlian", -1))
const _hoisted_280 = { class: "mb-2" }
const _hoisted_281 = { class: "mb-2 fv-row" }
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Sijil Badan Ikhtisas", -1))
const _hoisted_283 = ["href"]
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, null, -1))
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger fs-5" }, "**CATATAN: Hanya Senarai Badan Ikhtisas yang dikemukakan bersama salinan sijil keahlian penuh yang telah diluluskan sahaja akan diambilkira.", -1))
const _hoisted_286 = { "data-kt-stepper-element": "content" }
const _hoisted_287 = { class: "w-100" }
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Sahkan Maklumat Anda"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Sila tekan \"Sebelum\" jika anda perlu ubahsuai maklumat. ")
], -1))
const _hoisted_289 = { class: "mb-0" }
const _hoisted_290 = { class: "col-lg-12" }
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Diri Pemohon")
], -1))
const _hoisted_292 = { class: "d-flex flex-column" }
const _hoisted_293 = { class: "row mt-3 h-40px" }
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "No. Kad Pengenalan Baharu:")
], -1))
const _hoisted_295 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_296 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_298 = { class: "row h-40px" }
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nama Penuh:")
], -1))
const _hoisted_300 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_301 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_303 = { class: "d-flex justify-content-between flex-column mb-3" }
const _hoisted_304 = { class: "row h-40px" }
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Tarikh Lahir:", -1))
const _hoisted_306 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_307 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_309 = { class: "row h-40px" }
const _hoisted_310 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "No. Telefon Bimbit:", -1))
const _hoisted_311 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_312 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_314 = { class: "row h-40px" }
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "E-mel:", -1))
const _hoisted_316 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_317 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_319 = { class: "row h-40px" }
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Jantina:", -1))
const _hoisted_321 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_322 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_324 = { class: "row h-40px" }
const _hoisted_325 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Agama:", -1))
const _hoisted_326 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_327 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_329 = { class: "row h-40px" }
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Bangsa:", -1))
const _hoisted_331 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_332 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_333 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_334 = { class: "row" }
const _hoisted_335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Alamat Surat Menyurat:", -1))
const _hoisted_336 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_337 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_339 = { class: "row h-40px" }
const _hoisted_340 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Negeri:", -1))
const _hoisted_341 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_342 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_343 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_344 = { class: "row h-40px" }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Poskod:", -1))
const _hoisted_346 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_347 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_348 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_349 = { class: "row mt-3 h-40px" }
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Status Perkahwinan:")
], -1))
const _hoisted_351 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_352 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_354 = { class: "col-lg-12" }
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Perkhidmatan")
], -1))
const _hoisted_356 = { class: "d-flex flex-column" }
const _hoisted_357 = { class: "row mt-3 h-40px" }
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Jawatan Hakiki:")
], -1))
const _hoisted_359 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_360 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_362 = { class: "row mt-3 h-40px" }
const _hoisted_363 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gred Jawatan Semasa:")
], -1))
const _hoisted_364 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_365 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_366 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_367 = { class: "row h-40px" }
const _hoisted_368 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tarikh Lantikan Ke Perkhidmatan Sekarang:")
], -1))
const _hoisted_369 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_370 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_372 = { class: "d-flex justify-content-between flex-column mb-3" }
const _hoisted_373 = { class: "row h-40px" }
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Tarikh Sah ke Perkhidmatan:", -1))
const _hoisted_375 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_376 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_377 = {
  key: 0,
  class: "separator separator-dashed my-3"
}
const _hoisted_378 = {
  key: 1,
  class: "row h-40px"
}
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, "Tarikh Kenaikan Pangkat Terakhir:", -1))
const _hoisted_380 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_381 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_383 = { class: "row h-40px" }
const _hoisted_384 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Tarikh Memangku:", -1))
const _hoisted_385 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_386 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_387 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_388 = { class: "row h-40px" }
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Kementerian:", -1))
const _hoisted_390 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_391 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_393 = { class: "row h-40px" }
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Jabatan Bertugas Semasa:", -1))
const _hoisted_395 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_396 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_397 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_398 = { class: "row h-40px" }
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Alamat Pejabat:", -1))
const _hoisted_400 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_401 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_403 = { class: "row h-40px" }
const _hoisted_404 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Daerah:", -1))
const _hoisted_405 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_406 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_407 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_408 = { class: "row h-40px" }
const _hoisted_409 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Negeri:", -1))
const _hoisted_410 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_411 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_412 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_413 = { class: "row h-40px" }
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Poskod:", -1))
const _hoisted_415 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_416 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_418 = { class: "row h-40px" }
const _hoisted_419 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Telefon Pejabat:", -1))
const _hoisted_420 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_421 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_423 = { class: "row h-40px" }
const _hoisted_424 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "Faks:", -1))
const _hoisted_425 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_426 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_427 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_428 = { class: "row h-40px" }
const _hoisted_429 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "E-mel Ketua Jabatan:", -1))
const _hoisted_430 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_431 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_433 = { class: "row" }
const _hoisted_434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, " Senarai Pegawai PSM ", -1))
const _hoisted_435 = {
  class: "col-lg-8 d-flex align-items-center",
  style: {"padding-left":"0px"}
}
const _hoisted_436 = { class: "fw-bolder" }
const _hoisted_437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_438 = { key: 0 }
const _hoisted_439 = { class: "col-lg-12" }
const _hoisted_440 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Sijil Badan Ikhtisas")
], -1))
const _hoisted_441 = { class: "d-flex flex-column" }
const _hoisted_442 = { class: "row mt-3 h-40px" }
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nama Sijil Badan Ikhtisas:")
], -1))
const _hoisted_444 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_445 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_446 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_447 = { class: "row mt-3 h-40px" }
const _hoisted_448 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lampiran Sijil Badan Ikhtisas:")
], -1))
const _hoisted_449 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_450 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_451 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_452 = { class: "col-lg-12" }
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Pinjaman Pendidikan")
], -1))
const _hoisted_454 = { class: "d-flex flex-column" }
const _hoisted_455 = { class: "row mt-3 h-40px" }
const _hoisted_456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kenyataan:")
], -1))
const _hoisted_457 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_458 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_460 = { class: "row mt-3 h-40px" }
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Keterangan:")
], -1))
const _hoisted_462 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_463 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_464 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_465 = { class: "row h-40px" }
const _hoisted_466 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lampiran:")
], -1))
const _hoisted_467 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_468 = {
  class: "fw-bolder fs-6 text-dark",
  style: {"text-transform":"uppercase"}
}
const _hoisted_469 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_470 = {
  key: 1,
  class: "col-lg-12 mt-5"
}
const _hoisted_471 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-3 text-gray-800 text-hover-primary" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Butir-Butir Badan Ikhtisas")
], -1))
const _hoisted_472 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-4 text-gray-800 fw-bolder" }, "Maklumat Keahlian MIA", -1))
const _hoisted_474 = { class: "d-flex flex-column" }
const _hoisted_475 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-3 h-40px" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Keahlian MIA:")
  ]),
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted d-flex align-items-center" }, "No. Keahlian MIA:"),
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Tarikh Keahlian MIA:")
  ])
], -1))
const _hoisted_476 = { class: "row h-40px" }
const _hoisted_477 = {
  class: "col-lg-4 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_478 = {
  class: "col-lg-4 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_479 = {
  class: "col-lg-4 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_480 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_481 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-4 text-gray-800 fw-bolder" }, "Senarai Badan Ikhtisas", -1))
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row h-40px" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Badan Ikhtisas:")
  ]),
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Tarikh Lulus Peperiksaan:")
  ]),
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Tarikh Keahlian Penuh Diluluskan:")
  ]),
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 d-flex align-items-center fw-bold text-muted" }, [
    /*#__PURE__*/_createElementVNode("span", null, "No. Keahlian:")
  ])
], -1))
const _hoisted_483 = {
  class: "col-lg-3 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_484 = {
  class: "col-lg-3 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_485 = {
  class: "col-lg-3 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_486 = {
  class: "col-lg-3 d-flex align-items-center fw-bold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_488 = {
  key: 0,
  class: "mt-4 mb-2 col-lg-12 p-2"
}
const _hoisted_489 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Penempatan")
], -1))
const _hoisted_490 = { class: "col-lg-6" }
const _hoisted_491 = { class: "mb-2 fv-row" }
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label h-100" }, "Penempatan Khas Negeri", -1))
const _hoisted_493 = { class: "mb-2 d-flex text-bottom" }
const _hoisted_494 = {
  key: 1,
  class: "mt-4 mb-2 col-lg-12 p-2"
}
const _hoisted_495 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Pilihan Penempatan")
], -1))
const _hoisted_496 = { class: "mb-2 fv-row" }
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label h-100" }, "Pilihan Penempatan Pertama", -1))
const _hoisted_498 = { class: "mb-2 d-flex text-bottom col-lg-12" }
const _hoisted_499 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, " Sila Pilih Negeri ", -1))
const _hoisted_500 = ["value"]
const _hoisted_501 = { class: "input-group mb-3" }
const _hoisted_502 = ["onClick"]
const _hoisted_503 = { class: "mb-2 fv-row" }
const _hoisted_504 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label h-100" }, "Pilihan Penempatan Kedua", -1))
const _hoisted_505 = { class: "mb-2 d-flex text-bottom" }
const _hoisted_506 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, " Sila Pilih Negeri ", -1))
const _hoisted_507 = ["value"]
const _hoisted_508 = { class: "input-group mb-3" }
const _hoisted_509 = ["onClick"]
const _hoisted_510 = { class: "mt-5 mb-2 col-lg-12 p-2" }
const _hoisted_511 = { class: "col-lg-12" }
const _hoisted_512 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-gray-700 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "PENGAKUAN PEMOHON")
], -1))
const _hoisted_513 = { class: "notice d-flex flex-column bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_514 = { class: "d-flex" }
const _hoisted_515 = { class: "me-4" }
const _hoisted_516 = ["onUpdate:modelValue"]
const _hoisted_517 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_518 = { class: "fw-bold" }
const _hoisted_519 = { class: "fs-6 text-gray-600" }
const _hoisted_520 = {
  key: 0,
  class: "separator separator-dashed my-10"
}
const _hoisted_521 = { class: "d-flex flex-stack pt-15" }
const _hoisted_522 = { class: "me-2" }
const _hoisted_523 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_524 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_525 = { class: "indicator-label" }
const _hoisted_526 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Sila Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_528 = { class: "indicator-label" }
const _hoisted_529 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_530 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Sila Tunggu... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_531 = {
  key: 1,
  type: "submit",
  class: "btn btn-ispk-active btn-primary"
}
const _hoisted_532 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_FormTextarea = _resolveComponent("FormTextarea")!
  const _component_FormTextinput = _resolveComponent("FormTextinput")!
  const _component_FormDropdown = _resolveComponent("FormDropdown")!
  const _component_FormCheckbox = _resolveComponent("FormCheckbox")!
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_BorangPmkKnpFormPegawaiPsmComponent = _resolveComponent("BorangPmkKnpFormPegawaiPsmComponent")!
  const _component_FileField = _resolveComponent("FileField")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.borang.tajuk), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
            [_vShow, _ctx.borang.jenis_permohonan == 'IKHTISAS']
          ]),
          _hoisted_11
        ]),
        _createVNode(_component_Form, {
          class: "mx-auto mw-950px w-100 py-10",
          id: "BorangPerkhidmatan",
          onSubmit: _ctx.handleStep
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "no_kad_pengenalan",
                            class: "form-control mb-2",
                            placeholder: "IC BAHARU",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.no_kad_pengenalan) = $event)),
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, _ctx.form.no_kad_pengenalan],
                            [_directive_maska, '######-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("input", {
                              class: "form-check-input mx-2",
                              type: "radio",
                              name: "jantina",
                              checked: _ctx.form.jantina == 'Lelaki',
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jantina = false)),
                              disabled: ""
                            }, null, 8, _hoisted_25),
                            _hoisted_26,
                            _createElementVNode("input", {
                              class: "form-check-input mx-2",
                              type: "radio",
                              name: "jantina",
                              checked: _ctx.form.jantina == 'Perempuan',
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jantina = true)),
                              disabled: ""
                            }, null, 8, _hoisted_27),
                            _hoisted_28
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "sku",
                          class: "form-control mb-2",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.nama) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.nama]
                        ]),
                        _hoisted_32
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_lahir",
                            name: "tarikh_lahir",
                            modelValue: _ctx.form.tarikh_lahir,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.tarikh_lahir) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ageCount())),
                            disabled: !_ctx.isEditable
                          }, null, 8, ["modelValue", "disabled"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "umur",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.umur) = $event)),
                            disabled: !_ctx.isEditable
                          }, null, 8, _hoisted_40), [
                            [_vModelText, _ctx.form.umur]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "no_telefon_bimbit",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.no_telefon_bimbit) = $event)),
                            maxlength: "15",
                            disabled: !_ctx.isEditable
                          }, null, 8, _hoisted_45), [
                            [_vModelText, _ctx.form.no_telefon_bimbit]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            name: "emel",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.emel) = $event)),
                            maxlength: "100",
                            disabled: !_ctx.isEditable
                          }, null, 8, _hoisted_49), [
                            [_vModelText, _ctx.form.emel]
                          ]),
                          _hoisted_50
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select mb2",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.bangsa) = $event)),
                                  style: {"text-transform":"uppercase"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bangsaOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.kod,
                                      value: option.label
                                    }, _toDisplayString(option.label), 9, _hoisted_56))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.bangsa]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "emel",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.bangsa) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.form.bangsa]
                                ])
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select mb2",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.agama) = $event)),
                                  style: {"text-transform":"uppercase"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agamaOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.kod,
                                      value: option.label
                                    }, _toDisplayString(option.label), 9, _hoisted_62))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.agama]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "emel",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.agama) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.form.agama]
                                ])
                              ]))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _withDirectives(_createElementVNode("textarea", {
                          style: {"text-transform":"uppercase"},
                          class: "form-control",
                          "data-kt-autosize": "true",
                          rows: "2",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.alamat) = $event)),
                          disabled: !_ctx.isEditable
                        }, null, 8, _hoisted_67), [
                          [_vModelText, _ctx.form.alamat]
                        ]),
                        _hoisted_68
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _hoisted_72,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select mb2",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.tempat_tinggal_negeri) = $event)),
                                  style: {"text-transform":"uppercase"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.negeriOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.kod,
                                      value: option.label
                                    }, _toDisplayString(option.label), 9, _hoisted_74))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.tempat_tinggal_negeri]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "emel",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.tempat_tinggal_negeri) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.form.tempat_tinggal_negeri]
                                ])
                              ])),
                          _hoisted_76
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "poskod",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.poskod) = $event)),
                                  maxlength: "5",
                                  pattern: "\\d{5}",
                                  inputmode: "numeric",
                                  onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.poskod = _ctx.form.poskod.replace(/\D/g, '').slice(0,5)))
                                }, null, 544), [
                                  [_vModelText, _ctx.form.poskod]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "poskod",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.poskod) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.form.poskod]
                                ])
                              ])),
                          _hoisted_82
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _hoisted_87,
                            (_ctx.isEditable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: "form-select mb2",
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.status_perkahwinan) = $event)),
                                    style: {"text-transform":"uppercase"}
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusPerkahwinanOptions, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: option.kod,
                                        value: option.label
                                      }, _toDisplayString(option.label), 9, _hoisted_89))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.form.status_perkahwinan]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "emel",
                                    class: "form-control mb-2",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.status_perkahwinan) = $event)),
                                    disabled: ""
                                  }, null, 512), [
                                    [_vModelText, _ctx.form.status_perkahwinan]
                                  ])
                                ]))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.borang.medan_tambahan, (medan, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (medan.section === 'Butir-butir Diri')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                (medan.field.type === 'Textarea')
                                  ? (_openBlock(), _createBlock(_component_FormTextarea, {
                                      key: 0,
                                      label: medan.label,
                                      modelValue: _ctx.form.data_medan_tambahan[medan.label],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.form.data_medan_tambahan[medan.label]) = $event)
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                                  : (medan.field.type === 'Textbox')
                                    ? (_openBlock(), _createBlock(_component_FormTextinput, {
                                        key: 1,
                                        label: medan.label,
                                        modelValue: _ctx.form.data_medan_tambahan[medan.label],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.data_medan_tambahan[medan.label]) = $event)
                                      }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                                    : (medan.field.type === 'Dropdown')
                                      ? (_openBlock(), _createBlock(_component_FormDropdown, {
                                          key: 2,
                                          label: medan.label,
                                          options: medan.field.data,
                                          modelValue: _ctx.form.data_medan_tambahan[medan.label],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.data_medan_tambahan[medan.label]) = $event)
                                        }, null, 8, ["label", "options", "modelValue", "onUpdate:modelValue"]))
                                      : (medan.field.type === 'Checkbox')
                                        ? (_openBlock(), _createBlock(_component_FormCheckbox, {
                                            key: 3,
                                            label: medan.label,
                                            modelValue: _ctx.form.data_medan_tambahan[medan.label],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.data_medan_tambahan[medan.label]) = $event)
                                          }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                                        : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _hoisted_100,
                        (_ctx.isEditable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "jawatan_hakiki",
                                class: "form-control mb-2",
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.jawatan_hakiki) = $event)),
                                onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.jawatan_hakiki = _ctx.form.jawatan_hakiki.toUpperCase()))
                              }, null, 544), [
                                [_vModelText, _ctx.form.jawatan_hakiki]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "jawatan_hakiki",
                                class: "form-control mb-2",
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.jawatan_hakiki) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.form.jawatan_hakiki]
                              ])
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        (_ctx.isEditable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "emel",
                                class: "form-control mb-2",
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.gred) = $event)),
                                onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.gred = _ctx.form.gred.toUpperCase())),
                                maxlength: "10"
                              }, null, 544), [
                                [_vModelText, _ctx.form.gred]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "emel",
                                class: "form-control mb-2",
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.gred) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.form.gred]
                              ])
                            ])),
                        _hoisted_108
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _hoisted_112,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                _withDirectives(_createVNode(_component_datepicker, {
                                  id: "tarikh_lantikan_sekarang",
                                  name: "tarikh_lantikan_sekarang",
                                  modelValue: _ctx.form.tarikh_lantikan_sekarang,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.tarikh_lantikan_sekarang) = $event)),
                                  placeholder: "DD-MM-YYYY",
                                  textInput: "",
                                  autoApply: "",
                                  enableTimePicker: false,
                                  closeOnScroll: "",
                                  closeOnAutoApply: true,
                                  format: "dd-MM-yyyy"
                                }, null, 8, ["modelValue"]), [
                                  [_directive_maska, '##-##-####']
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                _withDirectives(_createVNode(_component_datepicker, {
                                  id: "tarikh_lantikan_sekarang",
                                  name: "tarikh_lantikan_sekarang",
                                  modelValue: _ctx.form.tarikh_lantikan_sekarang,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.tarikh_lantikan_sekarang) = $event)),
                                  placeholder: "DD-MM-YYYY",
                                  textInput: "",
                                  autoApply: "",
                                  enableTimePicker: false,
                                  closeOnScroll: "",
                                  closeOnAutoApply: true,
                                  format: "dd-MM-yyyy",
                                  disabled: ""
                                }, null, 8, ["modelValue"]), [
                                  [_directive_maska, '##-##-####']
                                ])
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("div", _hoisted_116, [
                          _hoisted_117,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_sah_perkhidmatan",
                            name: "tarikh_sah_perkhidmatan",
                            modelValue: _ctx.form.tarikh_sah_sekarang,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.tarikh_sah_sekarang) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy",
                            disabled: !_ctx.isEditable
                          }, null, 8, ["modelValue", "disabled"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _hoisted_121,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_memangku",
                            name: "tarikh_memangku",
                            modelValue: _ctx.form.tarikh_memangku,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.tarikh_memangku) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy"
                          }, null, 8, ["modelValue"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        false
                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                              _hoisted_124,
                              _withDirectives(_createVNode(_component_datepicker, {
                                id: "tarikh_naik_pangkat_terakhir",
                                name: "tarikh_naik_pangkat_terakhir",
                                modelValue: _ctx.form.tarikh_naik_pangkat_terakhir,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.tarikh_naik_pangkat_terakhir) = $event)),
                                placeholder: "DD-MM-YYYY",
                                textInput: "",
                                autoApply: "",
                                enableTimePicker: false,
                                closeOnScroll: "",
                                closeOnAutoApply: true,
                                format: "dd-MM-yyyy",
                                disabled: ""
                              }, null, 8, ["modelValue"]), [
                                [_directive_maska, '##-##-####']
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _hoisted_127,
                        _createElementVNode("div", _hoisted_128, [
                          _hoisted_129,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.persaraan) = $event)),
                            name: "tumpang",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.persaraan = !_ctx.persaraan))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.persaraan]
                          ]),
                          _hoisted_130
                        ])
                      ]),
                      (!_ctx.persaraan)
                        ? (_openBlock(), _createElementBlock("select", _hoisted_131, _hoisted_137))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, _ctx.ifJenisPersaraan]
                    ]),
                    (_ctx.persaraan)
                      ? _withDirectives((_openBlock(), _createBlock(_component_datepicker, {
                          key: 0,
                          id: "tarikh_persaraan",
                          name: "tarikh_persaraan",
                          modelValue: _ctx.form.tarikh_persaraan,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.tarikh_persaraan) = $event)),
                          placeholder: "DD-MM-YYYY",
                          textInput: "",
                          autoApply: "",
                          enableTimePicker: false,
                          closeOnScroll: "",
                          closeOnAutoApply: true,
                          format: "dd-MM-yyyy",
                          disabled: ""
                        }, null, 8, ["modelValue"])), [
                          [_directive_maska, '##-##-####']
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _hoisted_140,
                        (_ctx.isEditable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select mb2",
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.kementerian) = $event)),
                                style: {"text-transform":"uppercase"}
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kementerianOptions, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: option.kod,
                                    value: option.label
                                  }, _toDisplayString(option.label), 9, _hoisted_142))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.form.kementerian]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_143, [
                              _withDirectives(_createElementVNode("input", {
                                style: {"text-transform":"uppercase"},
                                type: "text",
                                name: "emel",
                                class: "form-control mb-2",
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.kementerian) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.form.kementerian]
                              ])
                            ])),
                        _hoisted_144
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _withDirectives(_createElementVNode("textarea", {
                          style: {"text-transform":"uppercase"},
                          class: "form-control",
                          "data-kt-autosize": "true",
                          rows: "2",
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.bertugas_alamat) = $event)),
                          disabled: !_ctx.isEditable
                        }, null, 8, _hoisted_148), [
                          [_vModelText, _ctx.form.bertugas_alamat]
                        ]),
                        _hoisted_149
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _hoisted_153,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select mb2",
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.bertugas_negeri) = $event)),
                                  style: {"text-transform":"uppercase"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.negeriOptions, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.kod,
                                      value: option.value
                                    }, _toDisplayString(option.label), 9, _hoisted_155))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.form.bertugas_negeri]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                _createElementVNode("input", {
                                  type: "text",
                                  name: "bertugas_negeri",
                                  class: "form-control mb-2",
                                  value: _ctx.selectedNegeri,
                                  disabled: ""
                                }, null, 8, _hoisted_157)
                              ])),
                          _hoisted_158
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("div", _hoisted_160, [
                          _hoisted_161,
                          (_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "poskod",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.bertugas_poskod) = $event)),
                                  maxlength: "5",
                                  pattern: "\\d{5}",
                                  inputmode: "numeric",
                                  onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.form.bertugas_poskod = _ctx.form.bertugas_poskod.replace(/\D/g, '').slice(0,5)))
                                }, null, 544), [
                                  [_vModelText, _ctx.form.bertugas_poskod]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  name: "bertugas_poskod",
                                  class: "form-control mb-2",
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.bertugas_poskod) = $event)),
                                  disabled: ""
                                }, null, 512), [
                                  [_vModelText, _ctx.form.bertugas_poskod]
                                ])
                              ])),
                          _hoisted_164
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", _hoisted_167, [
                          _hoisted_168,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "telefon_pejabat",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.no_telefon_pejabat) = $event)),
                            maxlength: "15",
                            disabled: !_ctx.isEditable
                          }, null, 8, _hoisted_169), [
                            [_vModelText, _ctx.form.no_telefon_pejabat]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _hoisted_172,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "pejabat_fax",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.no_faks_pejabat) = $event)),
                            maxlength: "15",
                            disabled: !_ctx.isEditable
                          }, null, 8, _hoisted_173), [
                            [_vModelText, _ctx.form.no_faks_pejabat]
                          ]),
                          (!_ctx.isEditable)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_174, "Butiran Perkhidmatan dari HRMIS"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("div", _hoisted_176, [
                        _hoisted_177,
                        _withDirectives(_createElementVNode("input", {
                          style: {"text-transform":"uppercase"},
                          type: "text",
                          name: "jawatan",
                          class: "form-control mb-2",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.jabatan_bertugas_semasa) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.form.jabatan_bertugas_semasa]
                        ]),
                        _hoisted_178
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_179, [
                      _hoisted_180,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select me-2",
                        name: "bertugas_negeri",
                        id: "bertugas_negeri",
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.bertugas_negeri) = $event)),
                        style: {"overflow":"hidden","text-overflow":"ellipsis"}
                      }, [
                        _hoisted_181,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: item.value,
                            style: {"text-transform":"uppercase"}
                          }, _toDisplayString(item.label), 9, _hoisted_182))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.bertugas_negeri]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_183, [
                      _createElementVNode("div", _hoisted_184, [
                        _hoisted_185,
                        _createElementVNode("i", {
                          onMouseover: _cache[46] || (_cache[46] = ($event: any) => (_ctx.showDaerahBertugas = true)),
                          onMouseleave: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showDaerahBertugas = false)),
                          class: "fas fa-exclamation-circle ms-2 fs-7",
                          "data-bs-toggle": "tooltip",
                          ref: "tooltipIcon",
                          style: {"cursor":"pointer"}
                        }, null, 544),
                        _createElementVNode("div", {
                          class: "alert alert-primary",
                          role: "alert",
                          style: _normalizeStyle(_ctx.styleDaerahBertugas)
                        }, [
                          _createTextVNode(" Sila masukkan Daerah Tempat Bertugas Semasa anda. "),
                          _hoisted_186,
                          _createTextVNode("Sekiranya tiada di dalam senarai, sila hubungi meja bantuan. ")
                        ], 4),
                        _createVNode(_component_VueSelect, {
                          class: "form-control me-2",
                          modelValue: _ctx.form.bertugas_bandar_kod,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.bertugas_bandar_kod) = $event)),
                          options: _ctx.filteredDaerahList,
                          label: 'nama_daerah',
                          reduce: (daerah) => daerah.kod_daerah,
                          placeholder: "Taip Untuk Mencari..."
                        }, null, 8, ["modelValue", "options", "reduce"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("div", _hoisted_188, [
                        _createElementVNode("div", _hoisted_189, [
                          _hoisted_190,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            name: "emel_ketua_jabatan",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.ketua_jabatan_emel) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.form.ketua_jabatan_emel]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_191, [
                        _createElementVNode("div", _hoisted_192, [
                          _hoisted_193,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            name: "emel_psm",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.psm_emel) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.form.psm_emel]
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_BorangPmkKnpFormPegawaiPsmComponent, {
                      onOnBahagianChanged: _ctx.psmBahagianChanged,
                      onOnListPsmMaklumatChanged: _ctx.listPsmMaklumatChanged,
                      initialSelectedBahagianId: _ctx.form.psm_bahagian_id,
                      onPsmListEmpty: _ctx.handlePsmListEmpty,
                      onPsmNotSelected: _ctx.handlePsmNotSelected
                    }, null, 8, ["onOnBahagianChanged", "onOnListPsmMaklumatChanged", "initialSelectedBahagianId", "onPsmListEmpty", "onPsmNotSelected"]),
                    (['IKHTISAS', 'PMK_WA41_WA44', 'PMK_WA44_WA48', 'PMK_WA48_WA52', 'PMK_WA52_WA54'].includes(_ctx.borang?.jenisPermohonan?.kod?.toUpperCase()))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                          _createElementVNode("div", _hoisted_195, [
                            _createElementVNode("div", _hoisted_196, [
                              _hoisted_197,
                              _createElementVNode("div", _hoisted_198, [
                                _createElementVNode("div", _hoisted_199, [
                                  _hoisted_200,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "nama_sijil_badan_ikhtisas",
                                    class: "form-control mb-2",
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.nama_sijil_badan_ikhtisas) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.form.nama_sijil_badan_ikhtisas]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_201, [
                                _createElementVNode("div", _hoisted_202, [
                                  _hoisted_203,
                                  _createVNode(_component_FileField, {
                                    name: "sijil_Ikhtisas",
                                    onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.handleSijilUpload($event, 'sijilBadanIkhtisas'))),
                                    accept: ".pdf, .PDF"
                                  }),
                                  _createElementVNode("a", {
                                    href: _ctx.form.sijilBadanIkhtisas?.url,
                                    target: "_blank",
                                    class: "d-inline-block text-truncate fs-6 text-muted text-hover-primary w-100"
                                  }, _toDisplayString(_ctx.form.sijilBadanIkhtisas?.nama_asal), 9, _hoisted_204),
                                  _hoisted_205
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_206, [
                      _createElementVNode("div", _hoisted_207, [
                        _hoisted_208,
                        _createElementVNode("div", _hoisted_209, [
                          _hoisted_210,
                          _withDirectives(_createElementVNode("select", {
                            style: {"text-transform":"uppercase"},
                            class: "form-select",
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.pernah_pinjaman_pendidikan) = $event))
                          }, _hoisted_215, 512), [
                            [_vModelSelect, _ctx.form.pernah_pinjaman_pendidikan]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("div", _hoisted_217, [
                        _createElementVNode("div", _hoisted_218, [
                          (_ctx.form.pernah_pinjaman_pendidikan != 'Tiada')
                            ? (_openBlock(), _createElementBlock("label", _hoisted_219, "Keterangan"))
                            : (_openBlock(), _createElementBlock("label", _hoisted_220, "Keterangan")),
                          _withDirectives(_createElementVNode("input", {
                            style: {"text-transform":"uppercase"},
                            type: "email",
                            name: "keterangan_pinjaman_pendidikana",
                            class: "form-control mb-2",
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.keterangan_pinjaman_pendidikan) = $event)),
                            disabled: _ctx.form.pernah_pinjaman_pendidikan == 'Tiada'
                          ? true
                          : false
                          
                          }, null, 8, _hoisted_221), [
                            [_vModelText, _ctx.form.keterangan_pinjaman_pendidikan]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_222, [
                        _createElementVNode("div", _hoisted_223, [
                          (_ctx.form.pernah_pinjaman_pendidikan != 'Tiada')
                            ? (_openBlock(), _createElementBlock("label", _hoisted_224, "Lampiran"))
                            : (_openBlock(), _createElementBlock("label", _hoisted_225, "Lampiran")),
                          _createVNode(_component_FileField, {
                            name: "pinjaman_pendidikan_lampiran",
                            onChange: _ctx.handleFileUpload,
                            disabled: _ctx.form.pernah_pinjaman_pendidikan == 'Tiada'
                          ? true
                          : false
                          ,
                            accept: ".pdf, .PDF, .doc, .docx"
                          }, null, 8, ["onChange", "disabled"]),
                          (_ctx.form.pinjaman_pendidikan_lampiran)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                _createElementVNode("a", {
                                  href: _ctx.form.pinjaman_pendidikan_lampiran?.url,
                                  target: "_blank",
                                  class: "fs-6 text-muted text-hover-primary"
                                }, _toDisplayString(_ctx.form.pinjaman_pendidikan_lampiran?.nama_asal), 9, _hoisted_227)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_228, [
              _createElementVNode("div", _hoisted_229, [
                _createElementVNode("div", _hoisted_230, [
                  _createElementVNode("div", _hoisted_231, [
                    _hoisted_232,
                    _createElementVNode("div", _hoisted_233, [
                      _createElementVNode("div", _hoisted_234, [
                        _createElementVNode("div", _hoisted_235, [
                          _hoisted_236,
                          _withDirectives(_createElementVNode("select", {
                            name: "keahlian_mia",
                            class: "form-select",
                            id: "mia",
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.jenis_ahli_mia) = $event))
                          }, _hoisted_240, 512), [
                            [_vModelSelect, _ctx.form.jenis_ahli_mia]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_241, [
                        _createElementVNode("div", _hoisted_242, [
                          _hoisted_243,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "no_ahli_mia",
                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.no_ahli_mia) = $event)),
                            class: "form-control"
                          }, null, 512), [
                            [_vModelText, _ctx.form.no_ahli_mia]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_244, [
                        _createElementVNode("div", _hoisted_245, [
                          _hoisted_246,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_ahli_mia",
                            name: "tarikh_ahli_mia",
                            modelValue: _ctx.form.tarikh_ahli_mia,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.form.tarikh_ahli_mia) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy"
                          }, null, 8, ["modelValue"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_247, [
                        _createElementVNode("div", _hoisted_248, [
                          _hoisted_249,
                          _createVNode(_component_FileField, {
                            name: "sijil_mia",
                            onChange: _cache[58] || (_cache[58] = ($event: any) => (_ctx.handleSijilUpload($event, 'sijilMIA'))),
                            accept: ".pdf, .PDF, .doc, .docx,"
                          }),
                          _createElementVNode("a", {
                            href: _ctx.form.sijilMIA?.url,
                            target: "_blank",
                            class: "d-inline-block text-truncate fs-6 text-muted text-hover-primary w-100"
                          }, _toDisplayString(_ctx.form.sijilMIA?.nama_asal), 9, _hoisted_250)
                        ])
                      ])
                    ]),
                    _hoisted_251,
                    _createElementVNode("div", _hoisted_252, [
                      _createElementVNode("div", _hoisted_253, [
                        _createElementVNode("div", _hoisted_254, [
                          _hoisted_255,
                          _createElementVNode("div", _hoisted_256, [
                            _hoisted_257,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              name: "badan_ikhtisas1",
                              id: "badan_ikhtisas1",
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.form.badan_ikhtisas[0].badan_ikhtisas) = $event)),
                              style: {"overflow":"hidden","text-overflow":"ellipsis"}
                            }, _hoisted_270, 512), [
                              [_vModelSelect, _ctx.form.badan_ikhtisas[0].badan_ikhtisas]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_271, [
                        _createElementVNode("div", _hoisted_272, [
                          _hoisted_273,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_lulus1",
                            name: "tarikh_lulus1",
                            modelValue: _ctx.form.badan_ikhtisas[0].tarikh_lulus,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.badan_ikhtisas[0].tarikh_lulus) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy"
                          }, null, 8, ["modelValue"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_274, [
                        _createElementVNode("div", _hoisted_275, [
                          _hoisted_276,
                          _withDirectives(_createVNode(_component_datepicker, {
                            id: "tarikh_keahlian_penuh1",
                            name: "tarikh_keahlian_penuh1",
                            modelValue: _ctx.form.badan_ikhtisas[0].tarikh_keahlian_penuh_lulus
                        ,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.form.badan_ikhtisas[0].tarikh_keahlian_penuh_lulus
                        ) = $event)),
                            placeholder: "DD-MM-YYYY",
                            textInput: "",
                            autoApply: "",
                            enableTimePicker: false,
                            closeOnScroll: "",
                            closeOnAutoApply: true,
                            format: "dd-MM-yyyy"
                          }, null, 8, ["modelValue"]), [
                            [_directive_maska, '##-##-####']
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_277, [
                        _createElementVNode("div", _hoisted_278, [
                          _hoisted_279,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "no_keahlian",
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.badan_ikhtisas[0].no_keahlian) = $event)),
                            class: "form-control mb-2 col-lg-4"
                          }, null, 512), [
                            [_vModelText, _ctx.form.badan_ikhtisas[0].no_keahlian]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_280, [
                        _createElementVNode("div", _hoisted_281, [
                          _hoisted_282,
                          _createVNode(_component_FileField, {
                            name: "sijil_Ikhtisas",
                            onChange: _cache[63] || (_cache[63] = ($event: any) => (
                        _ctx.handleSijilUpload($event, 'sijilBadanIkhtisas')
                        )),
                            accept: ".pdf, .PDF, .doc, .docx"
                          }),
                          _createElementVNode("a", {
                            href: _ctx.form.sijilBadanIkhtisas?.url,
                            target: "_blank",
                            class: "d-inline-block text-truncate fs-6 text-muted text-hover-primary w-100"
                          }, _toDisplayString(_ctx.form.sijilBadanIkhtisas?.nama_asal), 9, _hoisted_283),
                          _hoisted_284
                        ])
                      ])
                    ]),
                    _hoisted_285
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.borang.jenis_permohonan == 'IKHTISAS']
            ]),
            _createElementVNode("div", _hoisted_286, [
              _createElementVNode("div", _hoisted_287, [
                _hoisted_288,
                _createElementVNode("div", _hoisted_289, [
                  _createElementVNode("div", _hoisted_290, [
                    _hoisted_291,
                    _createElementVNode("div", _hoisted_292, [
                      _createElementVNode("div", _hoisted_293, [
                        _hoisted_294,
                        _createElementVNode("div", _hoisted_295, [
                          _createElementVNode("span", _hoisted_296, _toDisplayString(_ctx.form.no_kad_pengenalan), 1)
                        ])
                      ]),
                      _hoisted_297,
                      _createElementVNode("div", _hoisted_298, [
                        _hoisted_299,
                        _createElementVNode("div", _hoisted_300, [
                          _createElementVNode("span", _hoisted_301, _toDisplayString(_ctx.form.nama), 1)
                        ])
                      ])
                    ]),
                    _hoisted_302,
                    _createElementVNode("div", _hoisted_303, [
                      _createElementVNode("div", _hoisted_304, [
                        _hoisted_305,
                        _createElementVNode("div", _hoisted_306, [
                          _createElementVNode("span", _hoisted_307, _toDisplayString(_ctx.formatDate(_ctx.form.tarikh_lahir)), 1)
                        ])
                      ]),
                      _hoisted_308,
                      _createElementVNode("div", _hoisted_309, [
                        _hoisted_310,
                        _createElementVNode("div", _hoisted_311, [
                          _createElementVNode("span", _hoisted_312, _toDisplayString(_ctx.form.no_telefon_bimbit), 1)
                        ])
                      ]),
                      _hoisted_313,
                      _createElementVNode("div", _hoisted_314, [
                        _hoisted_315,
                        _createElementVNode("div", _hoisted_316, [
                          _createElementVNode("span", _hoisted_317, _toDisplayString(_ctx.form.emel), 1)
                        ])
                      ]),
                      _hoisted_318,
                      _createElementVNode("div", _hoisted_319, [
                        _hoisted_320,
                        _createElementVNode("div", _hoisted_321, [
                          _createElementVNode("span", _hoisted_322, _toDisplayString(_ctx.form.jantina), 1)
                        ])
                      ]),
                      _hoisted_323,
                      _createElementVNode("div", _hoisted_324, [
                        _hoisted_325,
                        _createElementVNode("div", _hoisted_326, [
                          _createElementVNode("span", _hoisted_327, _toDisplayString(_ctx.form.agama), 1)
                        ])
                      ]),
                      _hoisted_328,
                      _createElementVNode("div", _hoisted_329, [
                        _hoisted_330,
                        _createElementVNode("div", _hoisted_331, [
                          _createElementVNode("span", _hoisted_332, _toDisplayString(_ctx.form.bangsa), 1)
                        ])
                      ]),
                      _hoisted_333,
                      _createElementVNode("div", _hoisted_334, [
                        _hoisted_335,
                        _createElementVNode("div", _hoisted_336, [
                          _createElementVNode("span", _hoisted_337, _toDisplayString(_ctx.form.alamat), 1)
                        ])
                      ]),
                      _hoisted_338,
                      _createElementVNode("div", _hoisted_339, [
                        _hoisted_340,
                        _createElementVNode("div", _hoisted_341, [
                          _createElementVNode("span", _hoisted_342, _toDisplayString(_ctx.form.tempat_tinggal_negeri), 1)
                        ])
                      ]),
                      _hoisted_343,
                      _createElementVNode("div", _hoisted_344, [
                        _hoisted_345,
                        _createElementVNode("div", _hoisted_346, [
                          _createElementVNode("span", _hoisted_347, _toDisplayString(_ctx.form.poskod), 1)
                        ])
                      ]),
                      _hoisted_348,
                      _createElementVNode("div", _hoisted_349, [
                        _hoisted_350,
                        _createElementVNode("div", _hoisted_351, [
                          _createElementVNode("span", _hoisted_352, _toDisplayString(_ctx.form.status_perkahwinan), 1)
                        ])
                      ]),
                      _hoisted_353
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_354, [
                    _hoisted_355,
                    _createElementVNode("div", _hoisted_356, [
                      _createElementVNode("div", _hoisted_357, [
                        _hoisted_358,
                        _createElementVNode("div", _hoisted_359, [
                          _createElementVNode("span", _hoisted_360, _toDisplayString(_ctx.form.jawatan_hakiki), 1)
                        ])
                      ]),
                      _hoisted_361,
                      _createElementVNode("div", _hoisted_362, [
                        _hoisted_363,
                        _createElementVNode("div", _hoisted_364, [
                          _createElementVNode("span", _hoisted_365, _toDisplayString(_ctx.form.gred), 1)
                        ])
                      ]),
                      _hoisted_366,
                      _createElementVNode("div", _hoisted_367, [
                        _hoisted_368,
                        _createElementVNode("div", _hoisted_369, [
                          _createElementVNode("span", _hoisted_370, _toDisplayString(_ctx.form.tarikh_lantikan_sekarang
                          ? _ctx.formatDate(_ctx.form.tarikh_lantikan_sekarang)
                          : "-"), 1)
                        ])
                      ])
                    ]),
                    _hoisted_371,
                    _createElementVNode("div", _hoisted_372, [
                      _createElementVNode("div", _hoisted_373, [
                        _hoisted_374,
                        _createElementVNode("div", _hoisted_375, [
                          _createElementVNode("span", _hoisted_376, _toDisplayString(_ctx.form.tarikh_sah_sekarang
                          ? _ctx.formatDate(_ctx.form.tarikh_sah_sekarang)
                          : "-"), 1)
                        ])
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_377))
                        : _createCommentVNode("", true),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_378, [
                            _hoisted_379,
                            _createElementVNode("div", _hoisted_380, [
                              _createElementVNode("span", _hoisted_381, _toDisplayString(_ctx.form.tarikh_naik_pangkat_terakhir
                          ? _ctx.formatDate(_ctx.form.tarikh_naik_pangkat_terakhir)
                          : "-"), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_382,
                      _createElementVNode("div", _hoisted_383, [
                        _hoisted_384,
                        _createElementVNode("div", _hoisted_385, [
                          _createElementVNode("span", _hoisted_386, _toDisplayString(_ctx.form.tarikh_memangku
                          ? _ctx.formatDate(_ctx.form.tarikh_memangku)
                          : "-"), 1)
                        ])
                      ]),
                      _hoisted_387,
                      _createElementVNode("div", _hoisted_388, [
                        _hoisted_389,
                        _createElementVNode("div", _hoisted_390, [
                          _createElementVNode("span", _hoisted_391, _toDisplayString(_ctx.form.kementerian), 1)
                        ])
                      ]),
                      _hoisted_392,
                      _createElementVNode("div", _hoisted_393, [
                        _hoisted_394,
                        _createElementVNode("div", _hoisted_395, [
                          _createElementVNode("span", _hoisted_396, _toDisplayString(_ctx.form.jabatan_bertugas_semasa), 1)
                        ])
                      ]),
                      _hoisted_397,
                      _createElementVNode("div", _hoisted_398, [
                        _hoisted_399,
                        _createElementVNode("div", _hoisted_400, [
                          _createElementVNode("span", _hoisted_401, _toDisplayString(_ctx.form.bertugas_alamat), 1)
                        ])
                      ]),
                      _hoisted_402,
                      _createElementVNode("div", _hoisted_403, [
                        _hoisted_404,
                        _createElementVNode("div", _hoisted_405, [
                          _createElementVNode("span", _hoisted_406, _toDisplayString(_ctx.selectedDaerah), 1)
                        ])
                      ]),
                      _hoisted_407,
                      _createElementVNode("div", _hoisted_408, [
                        _hoisted_409,
                        _createElementVNode("div", _hoisted_410, [
                          _createElementVNode("span", _hoisted_411, _toDisplayString(_ctx.selectedNegeri), 1)
                        ])
                      ]),
                      _hoisted_412,
                      _createElementVNode("div", _hoisted_413, [
                        _hoisted_414,
                        _createElementVNode("div", _hoisted_415, [
                          _createElementVNode("span", _hoisted_416, _toDisplayString(_ctx.form.bertugas_poskod), 1)
                        ])
                      ]),
                      _hoisted_417,
                      _createElementVNode("div", _hoisted_418, [
                        _hoisted_419,
                        _createElementVNode("div", _hoisted_420, [
                          _createElementVNode("span", _hoisted_421, _toDisplayString(_ctx.form.no_telefon_pejabat), 1)
                        ])
                      ]),
                      _hoisted_422,
                      _createElementVNode("div", _hoisted_423, [
                        _hoisted_424,
                        _createElementVNode("div", _hoisted_425, [
                          _createElementVNode("span", _hoisted_426, _toDisplayString(_ctx.form.no_faks_pejabat), 1)
                        ])
                      ]),
                      _hoisted_427,
                      _createElementVNode("div", _hoisted_428, [
                        _hoisted_429,
                        _createElementVNode("div", _hoisted_430, [
                          _createElementVNode("span", _hoisted_431, _toDisplayString(_ctx.form.ketua_jabatan_emel), 1)
                        ])
                      ]),
                      _hoisted_432,
                      _createElementVNode("div", _hoisted_433, [
                        _hoisted_434,
                        _createElementVNode("div", _hoisted_435, [
                          _createElementVNode("ol", _hoisted_436, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPsmMaklumat, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'pegawai-psm-' + item.id
                              }, _toDisplayString(item.nama_penuh), 1))
                            }), 128))
                          ])
                        ])
                      ]),
                      _hoisted_437
                    ])
                  ]),
                  (['IKHTISAS', 'PMK_WA41_WA44', 'PMK_WA44_WA48', 'PMK_WA48_WA52', 'PMK_WA52_WA54'].includes(_ctx.borang?.jenisPermohonan?.kod?.toUpperCase()))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_438, [
                        _createElementVNode("div", _hoisted_439, [
                          _hoisted_440,
                          _createElementVNode("div", _hoisted_441, [
                            _createElementVNode("div", _hoisted_442, [
                              _hoisted_443,
                              _createElementVNode("div", _hoisted_444, [
                                _createElementVNode("span", _hoisted_445, _toDisplayString(_ctx.form.nama_sijil_badan_ikhtisas || '-'), 1)
                              ])
                            ]),
                            _hoisted_446,
                            _createElementVNode("div", _hoisted_447, [
                              _hoisted_448,
                              _createElementVNode("div", _hoisted_449, [
                                _createElementVNode("span", _hoisted_450, _toDisplayString(_ctx.sijils.sijilBadanIkhtisas?.name ??
                          _ctx.form.sijilBadanIkhtisas?.nama_asal), 1)
                              ])
                            ]),
                            _hoisted_451
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_452, [
                    _hoisted_453,
                    _createElementVNode("div", _hoisted_454, [
                      _createElementVNode("div", _hoisted_455, [
                        _hoisted_456,
                        _createElementVNode("div", _hoisted_457, [
                          _createElementVNode("span", _hoisted_458, _toDisplayString(_ctx.form.pernah_pinjaman_pendidikan == "Tiada"
                          ? "Tidak Mengambil Pinjaman Pendidikan"
                          : _ctx.form.pernah_pinjaman_pendidikan ==
                            "Dalam_Proses"
                            ? "Masih Dalam Proses Pembayaran (Penyata Pembayaran Dikepilkan Bersama)"
                            : _ctx.form.pernah_pinjaman_pendidikan == "Selesai"
                              ? "Telah Selesai Bayaran Pinjaman Pendidikan (Surat Akaun Pembayaran Penuh Pinjaman Dikepilkan Bersama) "
                        : "Tiada Rekod"), 1)
                        ])
                      ]),
                      _hoisted_459,
                      _createElementVNode("div", _hoisted_460, [
                        _hoisted_461,
                        _createElementVNode("div", _hoisted_462, [
                          _createElementVNode("span", _hoisted_463, _toDisplayString(_ctx.form.keterangan_pinjaman_pendidikan
                          ? _ctx.form.keterangan_pinjaman_pendidikan
                          : "-"), 1)
                        ])
                      ]),
                      _hoisted_464,
                      _createElementVNode("div", _hoisted_465, [
                        _hoisted_466,
                        _createElementVNode("div", _hoisted_467, [
                          _createElementVNode("span", _hoisted_468, _toDisplayString(_ctx.lampiran.pinjaman_pendidikan_lampiran?.name ??
                        _ctx.form.pinjaman_pendidikan_lampiran?.nama_asal), 1)
                        ])
                      ])
                    ]),
                    _hoisted_469
                  ]),
                  (_ctx.borang.jenis_permohonan == 'IKHTISAS')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_470, [
                        _hoisted_471,
                        _hoisted_472,
                        _hoisted_473,
                        _createElementVNode("div", _hoisted_474, [
                          _hoisted_475,
                          _createElementVNode("div", _hoisted_476, [
                            _createElementVNode("div", _hoisted_477, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.form.jenis_ahli_mia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_478, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.form.no_ahli_mia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_479, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.form.tarikh_ahli_mia)), 1)
                            ])
                          ]),
                          _hoisted_480,
                          _hoisted_481,
                          _hoisted_482,
                          (
                    (_ctx.form.badan_ikhtisas != null) &&
                    (_ctx.form.badan_ikhtisas.length > 0)
                  )
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.form.badan_ikhtisas, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "row h-40px",
                                  key: index
                                }, [
                                  _createElementVNode("label", _hoisted_483, [
                                    _createElementVNode("span", null, _toDisplayString(item.badan_ikhtisas ? item.badan_ikhtisas : "-"), 1)
                                  ]),
                                  _createElementVNode("label", _hoisted_484, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.tarikh_lulus)), 1)
                                  ]),
                                  _createElementVNode("label", _hoisted_485, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.tarikh_keahlian_penuh_lulus)), 1)
                                  ]),
                                  _createElementVNode("label", _hoisted_486, [
                                    _createElementVNode("span", null, _toDisplayString(item.no_keahlian ?? "-"), 1)
                                  ])
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_487
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.borang.penempatan_khas == 1 && _ctx.isPMK)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_488, [
                      _hoisted_489,
                      _createElementVNode("div", _hoisted_490, [
                        _createElementVNode("div", _hoisted_491, [
                          _hoisted_492,
                          _createElementVNode("div", _hoisted_493, [
                            _createVNode(_component_el_select, {
                              class: "form-control p-0 el-input-no-border",
                              name: "penempatan_khas",
                              id: "penempatan_khas",
                              modelValue: _ctx.form.penempatan_khas,
                              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.form.penempatan_khas) = $event)),
                              style: {"overflow":"hidden","text-overflow":"ellipsis","text-transform":"uppercase"},
                              onChange: _ctx.getLokasiPenempatanKhas,
                              "value-key": "lokasi"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.borang.lokasi_penempatan_khas, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    value: {
                          lokasi: item.lokasi,
                          poskod: item.poskod,
                          negeri: item.negeri,
                        },
                                    label: item.lokasi +
                          ',' +
                          item.poskod +
                          ',' +
                          _ctx.findLabel(item.negeri, _ctx.combo.negeri)
                          
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.borang.penempatan_khas == 0 && _ctx.isPMK)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_494, [
                        _hoisted_495,
                        _createElementVNode("div", _hoisted_496, [
                          _hoisted_497,
                          _createElementVNode("div", _hoisted_498, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select me-2",
                              name: "penempatan_pertama_negeri",
                              id: "penempatan_pertama_negeri",
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.form.penempatan_pertama_negeri) = $event)),
                              style: {"overflow":"hidden","text-overflow":"ellipsis"}
                            }, [
                              _hoisted_499,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: index,
                                  value: item.value,
                                  style: {"text-transform":"uppercase"}
                                }, _toDisplayString(item.label), 9, _hoisted_500))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.form.penempatan_pertama_negeri]
                            ]),
                            _createElementVNode("div", _hoisted_501, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["dropdown", { show: _ctx.isOpen1 }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Taip Daerah",
                                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.searchDaerah1) = $event)),
                                  onFocus: _cache[67] || (_cache[67] = ($event: any) => (_ctx.isOpen1 = true)),
                                  onInput: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.handleInput1 && _ctx.handleInput1(...args))),
                                  onKeydown: _cache[69] || (_cache[69] = _withKeys(($event: any) => (_ctx.isOpen1 = false), ["esc"])),
                                  style: {"text-transform":"uppercase"}
                                }, null, 544), [
                                  [_vModelText, _ctx.searchDaerah1]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["dropdown-menu", { show: _ctx.isOpen1 }]),
                                  style: {"max-height":"200px","overflow-y":"auto","width":"100%"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDaerah1, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: item.id,
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.selectDaerah1(item))
                                    }, _toDisplayString(item.nama_daerah), 9, _hoisted_502))
                                  }), 128))
                                ], 2)
                              ], 2)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "hidden",
                              "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.selectedDaerah1) = $event)),
                              name: "daerah1"
                            }, null, 512), [
                              [_vModelText, _ctx.selectedDaerah1]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "hidden",
                              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.form.penempatan_pertama) = $event)),
                              name: "daerah"
                            }, null, 512), [
                              [_vModelText, _ctx.form.penempatan_pertama]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "hidden",
                              "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.selectedDaerah1) = $event)),
                              name: "daerah1"
                            }, null, 512), [
                              [_vModelText, _ctx.selectedDaerah1]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_503, [
                          _hoisted_504,
                          _createElementVNode("div", _hoisted_505, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select me-2",
                              name: "penempatan_kedua_negeri",
                              id: "penempatan_kedua_negeri",
                              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.form.penempatan_kedua_negeri) = $event)),
                              style: {"overflow":"hidden","text-overflow":"ellipsis"}
                            }, [
                              _hoisted_506,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combo.negeri, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: index,
                                  value: item.value,
                                  style: {"text-transform":"uppercase"}
                                }, _toDisplayString(item.label), 9, _hoisted_507))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.form.penempatan_kedua_negeri]
                            ]),
                            _createElementVNode("div", _hoisted_508, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["dropdown", { show: _ctx.isOpen2 }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Taip Daerah",
                                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.searchDaerah2) = $event)),
                                  onFocus: _cache[75] || (_cache[75] = ($event: any) => (_ctx.isOpen2 = true)),
                                  onInput: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.handleInput2 && _ctx.handleInput2(...args))),
                                  onKeydown: _cache[77] || (_cache[77] = _withKeys(($event: any) => (_ctx.isOpen2 = false), ["esc"])),
                                  style: {"text-transform":"uppercase"}
                                }, null, 544), [
                                  [_vModelText, _ctx.searchDaerah2]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["dropdown-menu", { show: _ctx.isOpen2 }]),
                                  style: {"max-height":"200px","overflow-y":"auto","width":"100%"}
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDaerah2, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: item.id,
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.selectDaerah2(item))
                                    }, _toDisplayString(item.nama_daerah), 9, _hoisted_509))
                                  }), 128))
                                ], 2)
                              ], 2)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "hidden",
                              "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.selectedDaerah2) = $event)),
                              name: "daerah2"
                            }, null, 512), [
                              [_vModelText, _ctx.selectedDaerah2]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_510, [
                  _createElementVNode("div", _hoisted_511, [
                    _hoisted_512,
                    _createElementVNode("div", _hoisted_513, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.borang.perakuan, (perakuan, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("div", _hoisted_514, [
                            _createElementVNode("span", _hoisted_515, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input h-20px w-20px",
                                type: "checkbox",
                                value: "email",
                                name: "details_notifications[]",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.checkedPengakuan[index]) = $event)
                              }, null, 8, _hoisted_516), [
                                [_vModelCheckbox, _ctx.checkedPengakuan[index]]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_517, [
                              _createElementVNode("div", _hoisted_518, [
                                _createElementVNode("div", _hoisted_519, _toDisplayString(perakuan), 1)
                              ])
                            ])
                          ]),
                          (index + 1 < _ctx.borang.perakuan.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_520))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_521, [
              _createElementVNode("div", _hoisted_522, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-light-primary me-3",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.previousStep()))
                }, [
                  _createElementVNode("span", _hoisted_523, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createTextVNode(" Sebelum ")
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.currentStepIndex >= _ctx.totalSteps - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_524, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-lg mx-2 btn-success",
                        onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.formSubmit('DRAF')))
                      }, [
                        _createElementVNode("span", _hoisted_525, [
                          _createTextVNode(" Simpan Draf "),
                          _createElementVNode("span", _hoisted_526, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_527
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.formSubmit('HANTAR')))
                      }, [
                        _createElementVNode("span", _hoisted_528, [
                          _createTextVNode(" Hantar "),
                          _createElementVNode("span", _hoisted_529, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        _hoisted_530
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_531, [
                      _createTextVNode(" Seterusnya "),
                      _createElementVNode("span", _hoisted_532, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ], 512)
    ])
  ]))
}